function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as log from '../../../log';
import { contains } from '../../../util';
import { getMarkPropOrConfig, signalOrValueRef } from '../../common';
import { nonPosition } from './nonposition';
export function color(model) {
  var _opt$filled, _ref, _getMarkPropOrConfig, _getMarkPropOrConfig2;
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    filled: undefined
  };
  var markDef = model.markDef,
    encoding = model.encoding,
    config = model.config;
  var markType = markDef.type;
  // Allow filled to be overridden (for trail's "filled")
  var filled = (_opt$filled = opt.filled) !== null && _opt$filled !== void 0 ? _opt$filled : getMarkPropOrConfig('filled', markDef, config);
  var transparentIfNeeded = contains(['bar', 'point', 'circle', 'square', 'geoshape'], markType) ? 'transparent' : undefined;
  var defaultFill = (_ref = (_getMarkPropOrConfig = getMarkPropOrConfig(filled === true ? 'color' : undefined, markDef, config, {
    vgChannel: 'fill'
  })) !== null && _getMarkPropOrConfig !== void 0 ? _getMarkPropOrConfig :
  // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
  config.mark[filled === true && 'color']) !== null && _ref !== void 0 ? _ref :
  // If there is no fill, always fill symbols, bar, geoshape
  // with transparent fills https://github.com/vega/vega-lite/issues/1316
  transparentIfNeeded;
  var defaultStroke = (_getMarkPropOrConfig2 = getMarkPropOrConfig(filled === false ? 'color' : undefined, markDef, config, {
    vgChannel: 'stroke'
  })) !== null && _getMarkPropOrConfig2 !== void 0 ? _getMarkPropOrConfig2 :
  // need to add this manually as getMarkConfig normally drops config.mark[channel] if vgChannel is specified
  config.mark[filled === false && 'color'];
  var colorVgChannel = filled ? 'fill' : 'stroke';
  var fillStrokeMarkDefAndConfig = _objectSpread(_objectSpread({}, defaultFill ? {
    fill: signalOrValueRef(defaultFill)
  } : {}), defaultStroke ? {
    stroke: signalOrValueRef(defaultStroke)
  } : {});
  if (markDef.color && (filled ? markDef.fill : markDef.stroke)) {
    log.warn(log.message.droppingColor('property', {
      fill: 'fill' in markDef,
      stroke: 'stroke' in markDef
    }));
  }
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, fillStrokeMarkDefAndConfig), nonPosition('color', model, {
    vgChannel: colorVgChannel,
    defaultValue: filled ? defaultFill : defaultStroke
  })), nonPosition('fill', model, {
    // if there is encoding.fill, include default fill just in case we have conditional-only fill encoding
    defaultValue: encoding.fill ? defaultFill : undefined
  })), nonPosition('stroke', model, {
    // if there is encoding.stroke, include default fill just in case we have conditional-only stroke encoding
    defaultValue: encoding.stroke ? defaultStroke : undefined
  }));
}